module.exports = __webpack_public_path__ + "static/media/icon-image-light.20046d33.svg";